module.exports = __webpack_public_path__ + "fonts/iconfont.49a783e0.eot";